import {
  CalculateChangeSubscriptionPriceNewRequestBody,
  TokenPageableRequestParams,
} from "@gymflow/types";
import { QueryKey } from "@tanstack/react-query";

import { apiV2 } from "../../apiV2";

export const memberQueryKeys = {
  all: () => [...apiV2.staff.member.keys.all()] as QueryKey,
  allLegacy: () => [...apiV2.staff.member.keys.all(), "legacy"] as QueryKey,
  listNew: (
    pagination: TokenPageableRequestParams,
    params?: Readonly<{ [k: string]: any }>,
  ) => [...memberQueryKeys.allLegacy(), "list", pagination, params] as QueryKey,
  listNewCount: (params?: Readonly<{ [k: string]: any }>) =>
    [...memberQueryKeys.allLegacy(), "listCount", params] as QueryKey,
  list: (filters: Readonly<{ [k: string]: any }>) =>
    [...memberQueryKeys.allLegacy(), { filters }] as QueryKey,
  details: (memberId?: string) =>
    [...memberQueryKeys.allLegacy(), memberId] as QueryKey,
  detailsNew: (memberId?: string) =>
    [...memberQueryKeys.allLegacy(), "new", memberId] as QueryKey,
  paymentMethodsNew: (clubId: number, memberId?: string) =>
    [
      ...memberQueryKeys.allLegacy(),
      "paymentMethodsNew",
      clubId,
      memberId,
    ] as QueryKey,
  paymentMethod: (memberId?: string, paymentMethodId?: string) =>
    [
      ...memberQueryKeys.allLegacy(),
      "paymentMethod",
      memberId,
      paymentMethodId,
    ] as QueryKey,
  /*** @deprecated - use paymentMethodsNew instead*/
  paymentMethods: (clubId: number, memberId?: string) =>
    [
      ...memberQueryKeys.allLegacy(),
      "paymentMethods",
      clubId,
      memberId,
    ] as QueryKey,
  invoices: (memberId?: string, filters?: { [k: string]: any }) => {
    const result = [...memberQueryKeys.allLegacy(), memberId, "invoicesNew"];
    if (filters) result.push(filters);
    return result as QueryKey;
  },
  highlightedInvoice: (memberId?: string) =>
    [
      ...memberQueryKeys.allLegacy(),
      memberId,
      "invoicesNew",
      "highlightedInvoice",
    ] as QueryKey,
  invoiceFile: (invoiceNumber?: string) =>
    [...memberQueryKeys.allLegacy(), "invoiceFile", invoiceNumber] as QueryKey,
  searchByEmail: (email: string) =>
    [...memberQueryKeys.allLegacy(), "byEmail", email] as QueryKey,
  searchByFullName: (name: string, page: number, limit: number) =>
    [
      ...memberQueryKeys.allLegacy(),
      "byFullName",
      { name, page, limit },
    ] as QueryKey,
  search: (term: string, size: number, field?: string) =>
    [...memberQueryKeys.allLegacy(), "search", term, size, field] as QueryKey,
  calculateChangeSubscriptionPrice: ({
    membershipId,
    subscriptionId,
  }: CalculateChangeSubscriptionPriceNewRequestBody) =>
    [
      ...memberQueryKeys.allLegacy(),
      "calculateChangeSubscriptionPrice",
      subscriptionId,
      membershipId,
    ] as QueryKey,
  timeline: (memberId?: string, filters?: Readonly<{ [k: string]: any }>) =>
    [...memberQueryKeys.allLegacy(), memberId, "timeline", filters] as QueryKey,
  paymentMethodSetupIntent: (memberId?: string) =>
    [
      ...memberQueryKeys.details(memberId),
      "paymentMethodSetupIntent",
    ] as QueryKey,
  calculateScheduleDates: (subscriptionId: number) =>
    [
      ...memberQueryKeys.allLegacy(),
      "calculateScheduleDates",
      subscriptionId,
    ] as QueryKey,
  membershipLinkedMembers: (primarySubscriptionId?: number) =>
    [
      ...memberQueryKeys.allLegacy(),
      "membershipLinkedMembers",
      primarySubscriptionId,
    ] as QueryKey,
  addPromotionCodeToSubscription: (filters: {
    subscriptionId?: number;
    promotionCode?: string;
  }) =>
    [
      ...memberQueryKeys.allLegacy(),
      "addPromotionCodeToSubscription",
      filters.subscriptionId,
      filters.promotionCode,
    ] as QueryKey,
  invoice: (id: string) =>
    [...memberQueryKeys.allLegacy(), "invoice", id] as QueryKey,
  membershipChangeOptions: (id: number) =>
    [...memberQueryKeys.allLegacy(), "membershipChangeOptions", id] as QueryKey,
  userMemberSessionPackSubscriptionCurrent: (userMemberId: string) =>
    [
      ...memberQueryKeys.allLegacy(),
      "userMemberSessionPackSubscriptionCurrent",
      userMemberId,
    ] as QueryKey,
  userMemberSessionPackSubscriptionPrevious: (userMemberId: string) =>
    [
      ...memberQueryKeys.allLegacy(),
      "userMemberSessionPackSubscriptionPrevious",
      userMemberId,
    ] as QueryKey,
  userMemberSessionPackSubscriptionUsageHistory: (subscriptionId: number) =>
    [
      ...memberQueryKeys.allLegacy(),
      "userMemberSessionPackSubscriptionUsageHistory",
      subscriptionId,
    ] as QueryKey,
  profile: () => [...memberQueryKeys.allLegacy(), "profile"] as QueryKey,
};
